import { createEvent, restore, sample } from 'effector'
import { PermissionCreateItem } from './types'
import { fx } from '../../../../libs'

export const submitCreatePermission = createEvent<PermissionCreateItem>()

export const closeModal = createEvent()

export const createPermission = fx<PermissionCreateItem, void>({
  method: 'POST',
  url: '/permission',
})

sample({
  clock: submitCreatePermission,
  fn: (permission) => {
    return {
      url: `/permission`,
      body: { ...permission },
    }
  },
  target: createPermission,
})

export const $isSuccessCreate = restore(
  createPermission.doneData.map(() => true),
  false,
).reset(closeModal)
